import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { BANK_PATH, NEW_BANK_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { BANK_COLUMNS } from '../../../../config/columns';
import { clearBanks, getBanks } from '../../../../actions';

export const Banks = ({
  breadcrumbs,
  banks,
  loading,
  dispatchGetBanks,
  dispatchClearBanks,
}) => {
  useLayoutEffect(() => () => dispatchClearBanks(), []);

  const data = banks.get('content') || [];
  const pages = banks.get('totalPages') || null;
  const defaultPageSize = banks.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Bancos"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_BANK_PATH}
      tableStructure={{
        columns: BANK_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBanks,
        modelPath: BANK_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetBanks: getBanks,
  dispatchClearBanks: clearBanks,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Bancos',
      href: BANK_PATH,
    },
  ],
  banks: AccountingUnit.Bank.getIn(['all', 'content']),
  loading: AccountingUnit.Bank.getIn(['all', 'loading']),
});

Banks.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  banks: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetBanks: PropTypes.func.isRequired,
  dispatchClearBanks: PropTypes.func.isRequired,
};

Banks.defaultProps = {
  banks: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Banks);
